var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"interface-form-title-container"},[_c('div',{staticClass:"interface-form-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('Button',{attrs:{"label":_vm.$t('common.menu')},on:{"click":_vm.emitMenuOpen}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }